export default __webpack_public_path__ + "static/media/Giancarlo Possemato e Francesco Altan.90ab0a61.jpg";